module.exports = __webpack_public_path__ + "static/images/aircraft.a3670ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newPromotionImg/aircraft.png
// module id = JRH5
// module chunks = 11